/**
 * Copyright (c) 2024-2026 Creative Agentics Limited. All rights reserved.
 * Proprietary and confidential. Unauthorised use, reproduction or distribution
 * of this software, in whole or in part, is strictly prohibited.
 * See LICENSE.txt for full terms.
 */

// IS THIS LICENCE MONITORED AUTOMATICALLY? (v1_916) The daily monitoring job
// checks one register, the FCA Register by FRN, and only when the case names
// the FCA and records a licence number. Every other regulated case was skipped
// without a sign, so it looked monitored when it was not. The job, the case
// header, the weekly email and the periodic review all read this one test, so
// what is shown can never drift from what the job does. Pure.

const NOT_REGULATED = /^\s*(none|n\/?a|not (regulated|applicable|licensed|authorised)|unregulated|no regulator)\b/i;

export function licenceMonitoring(report) {
  const rs = (report && report.regulatoryStatus) || {};
  const regulatorRaw = typeof rs.regulator === 'string' ? rs.regulator.trim() : '';
  const licence = rs.licenceNumber != null ? String(rs.licenceNumber).trim() : '';
  const named = regulatorRaw && !NOT_REGULATED.test(regulatorRaw);
  const applies = rs.regulated === true || !!named;
  if (!applies) return { applies: false, monitored: false, source: null, regulator: null, reason: null };
  const regulator = named ? regulatorRaw : 'not named on the file';
  // The job's own test, unchanged: the regulator text contains "fca" and a
  // licence number is recorded.
  if (licence && regulatorRaw.toLowerCase().includes('fca')) {
    return { applies: true, monitored: true, source: 'fca', regulator, reason: null };
  }
  const reason = regulatorRaw.toLowerCase().includes('fca')
    ? 'no FRN is recorded on the file, so the FCA Register cannot be checked'
    : 'automatic licence monitoring covers the FCA Register only';
  return { applies: true, monitored: false, source: 'unsupported', regulator, reason };
}

// One sentence for the officer, no dashes.
export function licenceMonitoringSentence(lm) {
  if (!lm || !lm.applies || lm.monitored) return null;
  return 'Licence not monitored automatically (regulator: ' + lm.regulator + '; ' + lm.reason + '). Check it by hand on the regulator’s public register at each review.';
}
